/*Header */
var menu_image;
$('.menu li').hover(function() {
    menu_image=$(this).find('img').attr('src');
//    $('.image').addClass('change_background');
  //  setTimeout(function() {
    //  $('.image').css("background-image", "url(" + menu_image + ")");
    //  $('.image').removeClass('change_background');
  //  },1000);

});

/*Add alt to images*/
$(document).ready(function() {
    setTimeout(function() {
      $('img').each(function() {
         var altX = $(this).attr('alt');
         $(this).attr('alt', 'Madame Hortense');
       });
    },500);
});



/*scroll header*/
$(window).scroll(function() {
    if ($(document).scrollTop() > 700) {
        $('.header_wrapper').addClass('scrolled');
    }
    else{
      $('.header_wrapper').removeClass('scrolled');
    }
});

/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
       // downscroll code
       $('.header_wrapper').addClass('down');
   } else {
      // upscroll code
      $('.header_wrapper').removeClass('down');
   }
   lastScrollTop = st;
});


/*Language Switcher*/
$(".language.is-active").on('click', function() {
    return false;
})

/*Open Menu*/
$(".menu_button").on('click', function() {
      if($(this).hasClass('is-active')){
          $("body").css('overflow-y','scroll');
          $(this).removeClass('is-active');
          $('.menu_button').removeClass('is-active');
          $('.headermenu').removeClass('is-active');
        }
        else{
          $(this).addClass('is-active');
          jQuery("body").css('overflow-y','hidden');
          $('.headermenu').addClass('is-active');
      }

});



          /*Gallery Swipe*/
import Swiper, { Navigation } from 'swiper';
const gallery_swi = new Swiper(".gallery_swipe", {
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 1.5,
    loop: true,
    speed: 1200,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      769: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      991: {
        slidesPerView: 1.5,
        spaceBetween: 0,
      }
    }
});

const gallery_swi_loc = new Swiper(".gallery_swipe_loc", {
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 2,
    loop: true,
    speed: 500,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      769: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      991: {
        slidesPerView: 2,
        spaceBetween: 0,
      }
    }
});


/*Default Slider*/
$(document).ready(function () {
  var swiper_def = new Swiper(".slider_def_swipe", {
    loop:false,
    // effect: "fade",
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1500,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});

/*Default Slider Image*/
$(document).ready(function () {
  var swiper_def_image = new Swiper(".slider_def_image_swipe", {
    loop:false,
    // effect: "fade",
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1500,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction"
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});
var accommodation_background_color;
/*Room Swipe*/

  $(document).ready(function () {

    var swiper = new Swiper(".room_swipe", {
      //     autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      loop:true,
      slidesPerView: 1.3,
      spaceBetween: 40,
      speed: 1500,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 1.3,
          spaceBetween: 40,
        }
      },
      on: {
        init: function () {
          $(".swiper-progress-bar").removeClass("animate");
          $(".swiper-progress-bar").removeClass("active");
          $(".swiper-progress-bar").eq(0).addClass("animate");
          $(".swiper-progress-bar").eq(0).addClass("active");

          // const index_currentSlide      = this.realIndex;
          // const currentSlide            = this.slides[index_currentSlide]
          // accommodation_background_color=currentSlide.dataset.color;
          // console.log(currentSlide,accommodation_background_color);
          // $('#accommodation').css('background-color',accommodation_background_color);

        },
        slideChangeTransitionStart: function () {
          $(".swiper-progress-bar").removeClass("animate");
          $(".swiper-progress-bar").removeClass("active");
          $(".swiper-progress-bar").eq(0).addClass("active");
        },
        slideChangeTransitionEnd: function () {
          $(".swiper-progress-bar").eq(0).addClass("animate");

        },
        slideChange:function(){
          // const index_currentSlide      = this.realIndex;
          // const currentSlide            = this.slides[index_currentSlide]
          // accommodation_background_color=currentSlide.dataset.color;
          // console.log(currentSlide,accommodation_background_color);
          // $('#accommodation').css('background-color',accommodation_background_color);
        }
      }
    });

    $(".swiper-container").hover(function () {
      swiper.autoplay.stop();
      $(".swiper-progress-bar").removeClass("animate");
    }, function () {
      swiper.autoplay.start();
      $(".swiper-progress-bar").addClass("animate");
    });

  });

  /* Location Home*/
  $("#location .swiper-button-next").on('click', function() {
        $( "#location .wrapper h2" ).each(function( index ) {
          if($(this).hasClass('next')){
                $(this).removeClass('next');
          }else{
            $(this).addClass('next');
          }
        });

        $( "#location .wrapper .flex_wrapper .left" ).each(function( index ) {
          if($(this).hasClass('next')){
                $(this).removeClass('next');
          }else{
            $(this).addClass('next');
          }
        });
  });

  $("#location .swiper-button-prev").on('click', function() {
        $( "#location .wrapper h2" ).each(function( index ) {
          if($(this).hasClass('next')){
                $(this).removeClass('next');
          }else{
            $(this).addClass('next');
          }
        });

        $( "#location .wrapper .flex_wrapper .left" ).each(function( index ) {
          if($(this).hasClass('next')){
                $(this).removeClass('next');
          }else{
            $(this).addClass('next');
          }
        });
  });

/*Contact Form */
  $(document).ready(function(){
    $('.contact_form input').on('focus', function(){
      $(this).addClass('focused');
    });
    $('.contact_form textarea').on('focus', function(){
      $(this).addClass('focused');
    });

    $('.contact_form input').on('blur', function(){

      if  ( $(this).val() === '') {
         $(this).removeClass('focused');
      }
    });
    $('.contact_form textarea').on('blur', function(){

      if  ( $(this).val() === '') {
         $(this).removeClass('focused');
      }
    });

  });

  // For reCAPTCHA aria label accessibility error

  window.addEventListener('load', function() {
    var recaptchaElements = document.getElementsByClassName("g-recaptcha-response");
    recaptchaElements = Array.from(recaptchaElements);
    recaptchaElements.forEach((element) => {
      element.setAttribute("aria-hidden", "true");
      element.setAttribute("aria-label", "do not use");
      element.setAttribute("aria-readonly", "true");
    })
  })

  // when scroll reaches the bottom of the page do something
  window.addEventListener('scroll', function() {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      document.querySelector('.espa-banner').classList.add('reached-bottom');
      document.querySelector('#backtotop').classList.add('reached-bottom');
    } else {
      document.querySelector('.espa-banner').classList.remove('reached-bottom');
      document.querySelector('#backtotop').classList.remove('reached-bottom');
    }
  });